var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "features-card__wrapper"
  }, [_c("div", {
    staticClass: "features-card__container"
  }, _vm._l(_vm.featuresList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "features-card",
      class: {
        "flex-reverse": _vm.needReverseIndexArray.includes(index)
      }
    }, [_c("section", {
      staticClass: "features-card__left"
    }, [_c("img", {
      attrs: {
        src: item.img,
        alt: ""
      }
    })]), _c("section", {
      staticClass: "features-card__right"
    }, [_c("h4", [_vm._v(_vm._s(item.title))]), _c("section", {
      staticClass: "line"
    }), _c("p", [_vm._v(_vm._s(item.desc))])])]);
  }), 0)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };